<form [formGroup]="form">
  <div class="mt-4">
    <h3 i18n>E-Mail-Benachrichtigungen</h3>
    <hr />
    <div class="row mb-2">
      <div class="col-sm-8">
        <div class="row mb-3">
          <label class="col-sm-4 col-form-label fw-bold" i18n>Kontakt-E-Mail des Kundenkontos</label>
          <div class="col-sm-8">
            <label class="col-form-label" data-testid="settings-customer-contact-email">
              @if (profile?.customer?.email) {
                {{ profile.customer.email }}
              } @else {
                <span class="text-muted" i18n>nicht hinterlegt</span>
              }
            </label>
            <div>
              <a [routerLink]="['/shop-profile']" class="small" i18n>Unter „Meine Daten“ ändern</a>
            </div>
          </div>
        </div>
        <p class="text-muted small" i18n>
          Bestellbestätigungen gehen an die Benutzerin bzw. den Benutzer, die oder der
          bestellt hat. Bestellungen, die bei Ihnen eingehen, werden immer an die
          Kontakt-E-Mail des Kundenkontos gemeldet.
        </p>
        <h5 i18n>Diese Adresse zusätzlich verwenden für</h5>
        <div class="form-check">
          <input
            id="notifyCustomerEmailOnOrder"
            type="checkbox"
            class="form-check-input"
            formControlName="notifyCustomerEmailOnOrder"
            data-testid="settings-notify-customer-email-on-order"
            />
          <label class="form-check-label" for="notifyCustomerEmailOnOrder" i18n>
            Bestellbestätigungen eigener Einkäufe
          </label>
        </div>
      </div>
    </div>
  </div>

  <!-- #178 slice B / backend #682: the Customer-scoped language. Not the language
       anyone reads the app in — that one is per person, in the Benutzer tab — but the
       language of what this customer account SENDS: its seller order notices, and the
       invoices it issues. A different decision, by an admin, hence a different tab. -->
  <div class="mt-4">
    <h3 i18n>Sprache ausgehender Dokumente</h3>
    <hr />
    <div class="row mb-2">
      <div class="col-sm-8">
        <div class="row">
          <label class="col-sm-4 col-form-label" for="customerLanguage" i18n>Sprache</label>
          <div class="col-sm-8">
            <select
              id="customerLanguage"
              class="form-select"
              formControlName="customerLanguage"
              data-testid="settings-customer-language-select"
              >
              @for (language of customerLanguages; track language.code) {
                <option [value]="language.code" [disabled]="language.code === ''">
                  {{ language.name }}
                </option>
              }
            </select>
          </div>
        </div>
        <p class="text-muted small mt-2" i18n>
          Gilt für Bestellmeldungen an Ihr Kundenkonto und für Rechnungen, die Sie
          ausstellen. Eine Rechnung wird einmal erzeugt und gespeichert: bereits
          ausgestellte Rechnungen bleiben in der Sprache, in der sie erzeugt wurden.
          Die Sprache, in der Sie selbst die Oberfläche lesen, stellen Sie in der
          Registerkarte „Benutzer“ ein.
        </p>
      </div>
    </div>
  </div>

  <div class="mt-4">
    @if (profile?.isActive) {
      <button
        class="btn btn-primary m-2"
        type="button"
        data-testid="settings-notifications-save"
        [asyncClick]="save.bind(this)"
        [disabled]="saveBtn.disabled || form.pristine"
        #saveBtn="asyncClick"
        i18n
        >
        @if (saveBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
        Einstellungen speichern
      </button>
    }
  </div>
</form>
